export default __webpack_public_path__ + "static/media/background_leather.67f459dc.jpg";